import {
  axiosDelete,
  axiosGet,
  axiosPost,
  axiosPut,
} from '../../services/axiosService';

const baseSMSNotificationsURL = 'MessageTemplates';

export class SMSNotificationService {
  getSMSNotification() {
    return axiosGet(null, baseSMSNotificationsURL);
  }

  getSMSNotificationDetail(id) {
    return axiosGet(null, `${baseSMSNotificationsURL}/${id}`);
  }

  addSMSNotification(values) {
    return axiosPost(values, baseSMSNotificationsURL);
  }

  updateSMSNotifications(id, values) {
    return axiosPut(values, `${baseSMSNotificationsURL}/${id}`);
  }

  deleteSMSNotifications(id) {
    return axiosDelete(`${baseSMSNotificationsURL}/${id}`);
  }

  sendSMSNotification(file, id) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return axiosPost(formData, `${baseSMSNotificationsURL}/send?id=${id}`, {
      'Content-Type': 'multipart/form-data',
    });
  }
}